import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "basicFields", "inbodyFields", "photoField"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const selectedType = this.typeSelectTarget.value

    // 基本フィールドの表示制御
    if (this.hasBasicFieldsTarget) {
      this.basicFieldsTarget.style.display = (selectedType === 'home') ? 'none' : 'block'
    }

    // InBodyフィールドの表示制御
    if (this.hasInbodyFieldsTarget) {
      this.inbodyFieldsTarget.style.display = (selectedType === 'inbody') ? 'block' : 'none'
    }

    // 写真フィールドの表示制御（home以外で表示）
    if (this.hasPhotoFieldTarget) {
      this.photoFieldTarget.style.display = (selectedType === 'home') ? 'none' : 'block'
    }

    // 必須フィールドの制御
    this.updateRequiredFields(selectedType)
  }

  updateRequiredFields(type) {
    // 身長フィールド
    const heightField = this.element.querySelector('[name="body_measurement[height]"]')
    if (heightField) {
      heightField.required = (type !== 'home')
    }

    // 体重と体脂肪率（standard測定で必須）
    const weightField = this.element.querySelector('[name="body_measurement[weight]"]')
    const bodyFatField = this.element.querySelector('[name="body_measurement[body_fat_percentage]"]')

    if (weightField) {
      weightField.required = (type === 'standard')
    }
    if (bodyFatField) {
      bodyFatField.required = (type === 'standard')
    }
  }
}
